import axios from 'axios';

// const configLocal = localStorage.getItem('configPedidos');
// const baseURL = configLocal ? JSON.parse(configLocal).host : '';

const api = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    'app-key': process.env.VUE_APP_APP_KEY
  }
});

export default api;